import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import InputComponent from './Input';
import { TouchedLabel, TouchedInput } from './styled';
const InputWrapper = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;

  label {
    font-size: ${(props) => props.theme.fontSmall};
    transition: ${(props) => props.inputSettingsLoaded
    ? 'font-size 0.15s linear, margin-top 0.15s linear'
    : 'none'};
  }

  input {
    font-size: ${(props) => (props.inputSettingsLoaded ? '14px' : '0')};
  }

  input:-webkit-autofill + label {
    ${TouchedLabel};
    transition: none;
  }

  input:-webkit-autofill {
    ${TouchedInput}
  }

  ${(props) => props.otherBrowsersAutofill &&
    css `
      label {
        ${TouchedLabel};
        transition: none;
      }
    `}

  &.touched-style {
    input {
      ${TouchedInput}
    }

    label {
      ${TouchedLabel};
    }
  }
`;
const LabelText = styled.label `
  display: flex;
  color: #6c6c6c;
  position: absolute;
  top: 50%;
  left: 5px;
  line-height: 18px;
  margin: 0;
  cursor: text;
  margin-top: -11px;
  width: calc(100% - 10px);
  z-index: 2;
`;
const LabelBackground = styled.span `
  position: relative;
  padding-left: 5px;
  padding-right: 10px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(props) => props.required &&
    css `
      &:before {
        content: '*';
        padding-right: 3px;
      }
    `}
`;
const AutentiInput = ({ required, label, className, inputProps, labelProps, inputMeta, toggleIconProps, }) => {
    const [inputSettingsLoaded, setLoad] = useState(false);
    const hasValue = inputProps.value.length > 0;
    const hasActive = inputMeta.active;
    const isTouchedStyle = hasValue || hasActive;
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const loadTime = isChrome ? 300 : 0;
    useEffect(() => {
        if (!inputSettingsLoaded) {
            setTimeout(() => {
                setLoad(true);
            }, loadTime);
        }
        return () => {
            if (inputSettingsLoaded) {
                setLoad(false);
            }
        };
    }, []);
    return (React.createElement(InputWrapper, { className: `${className} ${isTouchedStyle ? 'touched-style' : ''}`, inputSettingsLoaded: inputSettingsLoaded, otherBrowsersAutofill: !isChrome && hasValue },
        React.createElement(InputComponent, { inputProps: Object.assign({}, inputProps), toggleIconProps: toggleIconProps }),
        inputSettingsLoaded && (React.createElement(LabelText, Object.assign({}, labelProps),
            React.createElement(LabelBackground, { required: required, className: "label-background" }, label)))));
};
AutentiInput.defaultProps = {
    required: false,
    labelProps: null,
    className: '',
    label: null,
};
export default AutentiInput;
